import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ element, adminOnly = false }) => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);
  const { permissions, loading: permissionsLoading } = useSelector((state) => state.permissions);
  const location = useLocation();


  // 🕒 Wait until both user + permissions are ready
  if (loading || permissionsLoading) {
    return <div>Please wait... Loading session and permissions</div>;
  }

  const currentPath = location.pathname.replace(/\/+$/, "");

  // 🚫 Not logged in
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // 🔒 Admin-only check
  if (adminOnly && user.role_name !== "admin") {
    return <Navigate to="/unauthorized" replace />;
  }

  // ✅ Permission-based check
  const hasPermission = permissions?.some((p) => {
    if (!p.page_url || !p.active) return false;

    const pageUrl = p.page_url.replace(/\/+$/, "");

    const pattern = pageUrl
      .replace(/:[^/]+/g, "[^/]+")
      .replace(/\//g, "\\/");

    const regex = new RegExp(`^${pattern}$`, "i");

    return regex.test(currentPath) && Number(p.roleid) === Number(user.roleid);
  });

  if (!hasPermission) {

      // ⭐️ SPECIAL CASE: Missing `/dashboard` permission
    if (currentPath === "/dashboard") {
      return <Navigate to="/" replace />;
    }
    else{
    console.warn(
      "❌ Access denied:",
      currentPath,
      "| Role:",
      user.role_name,
      "| Role ID:",
      user.roleid
    );
    return <Navigate to="/unauthorized" replace />;
  }
  }

  // ✅ Authorized
  return element;
};

export default ProtectedRoute;
